import * as React from 'react';
import {getProductWidgetSettingsFromProps} from '../../commons/styleParamsService';
import {WidgetDirectionEnum, WidgetAreaEnum} from '../../commons/enums';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import classnames from 'classnames';
import {IProvidedGlobalProps, withGlobalProps} from '../../providers/globalPropsProvider';
import {ContentArea} from '../ContentArea/ContentArea';
import {MediaArea} from '../MediaArea/MediaArea';
import {Property} from 'csstype';
import s from './ProductWidgetLayout.scss';
import borderAreaStyle from './borderArea.scss';

export enum DataHook {
  Root = 'product-widget-layout',
}

export interface IProductWidgetLayoutProps extends IProvidedTranslationProps, IProvidedGlobalProps {}

class ProductWidgetLayoutComp extends React.Component<IProductWidgetLayoutProps> {
  private readonly handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const {
      globals: {navigate},
    } = this.props;

    event.preventDefault();
    void (navigate && navigate());
  };

  public render(): React.ReactNode {
    const {
      globals: {productPageUrl, horizontalLayout},
    } = this.props;
    const settings = getProductWidgetSettingsFromProps(this.props);
    let direction: Property.FlexDirection;
    if (!horizontalLayout) {
      direction = 'column';
    } else if (settings.widgetDirection === WidgetDirectionEnum.LEFT) {
      direction = 'row';
    } else {
      direction = 'row-reverse';
    }

    return (
      <a
        data-hook={DataHook.Root}
        href={productPageUrl}
        onClick={this.handleClick}
        style={{flexDirection: direction, textDecoration: 'none'}}
        className={classnames(s.productWidgetLayout, {
          [borderAreaStyle.borderAreaHover]: settings.hoverBorderArea === WidgetAreaEnum.ALL,
        })}>
        <MediaArea />
        <ContentArea />
      </a>
    );
  }
}

export const ProductWidgetLayout = withGlobalProps(withTranslations('globals.texts')(ProductWidgetLayoutComp));
